/**
 * Firestore の再接続を今すぐ行う(2026-09-30 指摘: 申請の送信が「送信中」のまま止まって見える)。
 *
 * 電波が弱い・スマホがスリープした等で通信が途切れると、Firestore は再接続を
 * 1秒→2秒→4秒…と間隔を空けて試す(最大60秒)。この待ち時間の途中に操作すると、
 * 回線自体は戻っていても、待ち時間が明けるまで何十秒も返ってこない。
 * 一度オフラインにしてから戻すと、この待ち時間がリセットされて即座につなぎ直す。
 *
 * - 書き込みの途中で呼んでも安全: 送信待ちの書き込みは端末内の待ち行列に残り、
 *   つながった時点で自動的に送られる(消えない)
 * - 同時に何度も呼ばれないようにしている
 */
import { disableNetwork, enableNetwork } from 'firebase/firestore';
import { getDb } from './firebase';

let running: Promise<void> | null = null;

export function reconnectNow(): Promise<void> {
  if (running) return running;
  running = (async () => {
    try {
      const db = getDb();
      await disableNetwork(db);
      await enableNetwork(db);
    } catch (e) {
      // つなぎ直しに失敗しても、通常の再接続(待ち時間つき)は続くので致命的ではない
      console.error('Firestoreのつなぎ直しに失敗しました', e);
    } finally {
      running = null;
    }
  })();
  return running;
}
